import React, { useState } from "react";
import { Container } from "../components/Overview/OverviewElements";
import VideoEngagementTable from "../components/VideoEngagement/VideoEngagementTable";
import VideoCommentsTable from "../components/VideoEngagement/VideoCommentsTable";
import VideoEngagementStats from "../components/VideoEngagement/VideoEngagementStats";
import FileManager from "../components/FileManager/FileManager";
import WelcomeText from "../components/NewDashboard/WelcomeText";
import { Tabs, Tab, Box } from "@mui/material";
import styled from "@emotion/styled";

const StyledTabs = styled(Tabs)`
  margin-bottom: 20px;
  .MuiTabs-indicator {
    background-color: #4880FF;
  }
`;

const StyledTab = styled(Tab)`
  text-transform: none;
  font-family: "Nunito Sans", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #666;
  &.Mui-selected {
    color: #4880FF;
  }
`;

const VideoEngagementPage = ({ isAdmin = false }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container style={{ width: "100%", maxWidth: "100%" }}>
      <WelcomeText/>
      <VideoEngagementStats />
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <StyledTabs value={currentTab} onChange={handleTabChange}>
          <StyledTab label="Video Engagement" />
          <StyledTab label="Comments" />
          <StyledTab label="File Manager" />
        </StyledTabs>
      </Box>

      {currentTab === 0 && <VideoEngagementTable isAdmin={isAdmin} />}
      {currentTab === 1 && <VideoCommentsTable />}
      {currentTab === 2 && <FileManager />}
    </Container>
  );
};

export default VideoEngagementPage;
